import React from 'react';
import { CheckCircle, Plane } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FlightBookingAssistance: React.FC = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/eligibility?service=travel');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20">
            <div className="bg-[#009B8F] text-white py-16 mb-16">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-serif mb-4">Flight Booking Assistance</h1>
                    <p className="text-xl text-white/90 max-w-2xl">
                        Currently Available Only in the UK
                    </p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-6">
                <div className="flex items-center gap-4 mb-8">
                    <div className="p-3 bg-[#009B8F]/10 rounded-full">
                        <Plane className="text-[#009B8F] w-8 h-8" />
                    </div>
                    <h2 className="text-3xl font-serif text-[#011E26]">Stress-Free Travel Planning</h2>
                </div>

                <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-8">
                    <p className="text-amber-800 text-sm font-medium">
                        <strong>Note:</strong> NexOverseas is currently under construction, and at the moment, our services are available exclusively in the UK.
                    </p>
                </div>

                <div className="prose prose-lg text-slate-600 max-w-none">
                    <p className="mb-4">
                        We are committed to providing safe, reliable, and premium relocation support for clients preparing to move abroad.
                    </p>
                    <p className="mb-4">
                        Our Flight Booking Assistance service is designed to take the stress out of planning your overseas journey. We help you find the best flights, tailored to your schedule, destination, and relocation needs.
                    </p>

                    <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#009B8F] mb-8">
                        <h3 className="text-lg font-bold text-[#011E26] mb-3 uppercase tracking-wide">Our service includes:</h3>
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {[
                                "Personalised flight guidance tailored to your needs",
                                "Exclusive discounts for NexOverseas clients",
                                "Full support in case of cancellations or issues",
                                "Help with refunds and rebooking when needed"
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-2 text-sm font-medium">
                                    <CheckCircle className="w-5 h-5 text-[#009B8F] flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <p className="mb-6">
                        Beyond simply booking tickets, NexOverseas offers personalised guidance, exclusive discounts for our clients, and full support in case of cancellations or issues, including help with refunds. With us, your travel plans are handled professionally and safely, so you can focus on preparing for your exciting move abroad.
                    </p>

                    <button
                        onClick={handleContactClick}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg"
                    >
                        Get in Touch
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FlightBookingAssistance;
